/**
 * IQD has no usable sub-unit. Round to 0dp at the display boundary;
 * never mutate the underlying data.
 * Western digits in both locales — parity with the storefront's iqd()
 * (src/pages/marketplace/format.ts), per merchant credibility review.
 */
const iqdFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

export const formatIqd = (n: number): string =>
  iqdFormatter.format(Math.round(n || 0));
